/** API 엔드포인트 및 폴링 설정 */
const API_BASE = "";

export const API_ENDPOINTS = {
  analyze: `${API_BASE}/api/analyze`,
  jobStatus: (jobId: string) => `${API_BASE}/api/job/${jobId}/status`,
  popular: `${API_BASE}/api/popular`,
  market: `${API_BASE}/api/market`,
  stocks: `${API_BASE}/api/stocks`,
  autocomplete: (q: string) => `${API_BASE}/api/autocomplete?q=${encodeURIComponent(q)}`,
  vapidPublicKey: `${API_BASE}/api/push/vapid-public-key`,
  pushSubscribe: `${API_BASE}/api/push/subscribe`,
  watchScoreHistory: (codes: string[]) =>
    `${API_BASE}/api/watch/score-history?codes=${encodeURIComponent(codes.join(","))}`,
} as const;

/** 분석 작업 폴링 간격/타임아웃 */
export const POLLING = {
  /** 전체 폴링 타임아웃 (3분) */
  timeoutMs: 180_000,
  /** 대기열 상태 폴링 간격 (점진 증가, 최대 5초) */
  queueInterval: (attempt: number) => Math.min(2000 + attempt * 500, 5000),
  /** 분석 진행 중 폴링 간격 (점진 증가, 최대 3초) */
  processingInterval: (attempt: number) => Math.min(1000 + attempt * 200, 3000),
  /** 일시 오류 시 재시도 간격 */
  errorRetryMs: 2000,
} as const;
